import { ShippingMethod } from './enums';

export const METHOD_DISPLAY_VALUES = {
  [ShippingMethod.UPS]: 'UPS',
  [ShippingMethod.FEDEX]: 'FedEx',
  [ShippingMethod.CUSTOMER_PICKUP]: 'Customer Pickup',
  [ShippingMethod.TOG_DELIVERY]: 'TOG Delivery',
  [ShippingMethod.COURIER]: 'Courier',
  [ShippingMethod.EXPORT]: 'Export',
  [ShippingMethod.CUSTOMER_PICKUP_GAC]: 'Customer Pickup GAC',
  [ShippingMethod.EXPORTS_COURIER]: 'Exports / Courier',
  [ShippingMethod.DISCARD]: 'Discard',
};

export const SHIPMENT_FIELD_LABELS: Record<string, string> = {
  ownerId: 'Account',
  needByDate: 'Need By Date',
  originalNeedByDate: 'Original Need By Date',
  shipmentStatus: 'Shipment Status',
  shipFromSiteId: 'Ship From Site',
  date: 'Date',
  requestedBy: 'Requested By',
  phone: 'Contact Phone',
  email: 'Contact Email',
  shipToId: 'Ship To',
  shipName: 'Ship Name',
  shipAddress: 'Ship Address',
  shipAddress2: 'Ship Address 2',
  shipAddress3: 'Ship Address 3',
  shipCity: 'Ship City',
  shipState: 'Shipping State',
  shipZip: 'Ship Zip Code',
  amount: 'Amount',
  tank: 'Tank / Incubator',
  shippingMethod: 'Shipping Method',
  trackingNumber: 'Tracking Number',
  callTag: 'Call Tag',
  shipmentCategory: 'Shipment Category',
  packedById: 'Packed By Id',
  billTo: 'Bill To',
  billStatus: 'Bill Status',
  comment: 'Comment',
};

export const getShipmentFieldLabel = (key: string): string => {
  return SHIPMENT_FIELD_LABELS[key] || key;
};
